import React from 'react';
import ApplicationItem from './ApplicationItem';
import WebAPI from '../api/WebAPI.js';
import { connect } from 'react-redux'
//import queryString from 'query-string';
import { withRouter } from 'react-router';
import AppCommHandler from '../api/AppCommHandler';
import axios from 'axios';
class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {appType:'APP',containerHeight:'auto'};
        this.handleBack = this.handleBack.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }
    componentDidMount() {
		AppCommHandler.APIBreadcrumbEvent("");
        // fetch data initially in scenario 2 from above
        var appType = (this.props.match.params === undefined || this.props.match.params.appType === undefined) ? 'APP' : this.props.match.params.appType;
		this.setState({ appType: appType});
        this.props.fetchAppDetail(appType);
        this.props.fetchDashboard(appType);
        window.addEventListener('resize', this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    componentDidUpdate(prevProps) {
        // respond to parameter change in scenario 3
        let oldAppType = (prevProps.match.params === undefined || prevProps.match.params.appType === undefined) ? 'APP' : prevProps.match.params.appType;
        let newAppType = (this.props.match.params === undefined || this.props.match.params.appType === undefined) ? 'APP' : this.props.match.params.appType;
        if (oldAppType !== newAppType) {
			this.setState({ appType: newAppType});
            this.props.fetchAppDetail(newAppType);
            this.props.fetchDashboard(newAppType);
        }
        var x = document.getElementsByClassName("applications-wrapper");
        let maxHeight = 0;
        for (var i = 0; i < x.length; i++) {
            maxHeight=maxHeight>x[i].clientHeight?maxHeight:x[i].clientHeight;
        }
        if(this.state.containerHeight === 'auto' && maxHeight != 0){
            this.setState({containerHeight : maxHeight+'px'});
        }
        
    }
	handleBack(e) {
        this.props.history.push(window.env.appcontext);
    }

    handleResize(e) {
        this.setState({containerHeight: 'auto'});
    }
    render(props) {
        const equalHeightStyle = {
            height:this.state.containerHeight
          };
          if(this.props.dashboard.initialized && this.props.dashboard.applicationList.length!=0) {
        return (

            <div className="card bg-transparent border-0">
                {/* <div className="card-heading card-header-body-content">
                    <div className="grid-main-heading">
                        <span className="main-title">{this.props.dashboard.title}</span>
						{this.state.appType !== "APP" ?
						(<button id="back" type="button" onClick={this.handleBack} className="btn btn-back btn-primary float-end">Back</button>):null}
                    </div>
                </div> */}
                <div className="card-body">
					
                    <div className="row col-12 col-sm-12 col-md-12 col-lg-12 ">
                        <div className="alert-instructions">
                            <h4 className="text-bold">Instruction</h4>
                            <p>{/*<span className="text-orange"></span> */}Please select an application below</p>
                            {/* <p><span className="text-orange">*</span> If you need more information about the application click on the "Help" button corresponding to the application desired.</p> */}
                        </div>
                    </div>
                    <div className="row row-applications-wrapper">
                        {this.props.dashboard.applicationList.map((application, index) => <ApplicationItem containerStyle={equalHeightStyle} application={application} key={application.name} />)}
                        
                        {(this.state.appType === "APP" && window.env.SHOW_HELP==="Y") ?
                        (<div className="col-12 col-sm-6 col-md-4 col-lg-3 col-application">
			                  <div className="user-guide-wrapper" style={equalHeightStyle}>
			                  		<a target="_blank" href={window.env.API_URL + "/DocViewer/OAAM"}>
				                      <div className="user-guide-manual-wrapper">
				                          <div className="user-guide-side-decor"></div>
				                          <div className="user-guide-spacer-50"></div>
				                          <h5 className="user-guide-subtitle"></h5>
				                          <h3 className="user-guide-title">client reference guide</h3>
				                       </div>
				                     </a>
			                       		<div className="user-guide-buttons-wrapper">
			                       		<a target="_blank" href={window.env.API_URL + "/DocViewer/OAAM"}>
			                       			<button type="button" className="btn btn-secondary btn-user-guide">
					                          	<span className="icon-ic_help_outline_black_24px"></span> Help
					                      	</button>
				                      	</a>
				                  </div>   
			                  </div>
		                 </div>):null}
		                 
                    </div>
                </div>
            </div>

        );
     } else if(this.props.dashboard.initialized && this.props.dashboard.applicationList.length == 0) {
            return (
                <div class="row row-applications  card-shadow">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 applications-heading">
                        <p className="applications-instructions">No application is available for this user</p>
                    </div>
                </div>
            );
        } else {
            return (
                <div class="row row-applications  card-shadow">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 applications-heading">
                        <p className="applications-instructions">Loading Dashboard...</p>
                    </div>
                </div>
            );
        }
		
    }
    
}


const mapStateToProps = (state) => {
    return {
        dashboard: state.dashboard
    }
}

function mapDispatchToProps(dispatch) {
    return ({
        fetchDashboard: (appType) => {
            dispatch({
                type: "DASHBOARD_FETCH",
                payload: WebAPI.getData('/app/', { appType: appType }),
                appType: appType
            })
        },
        fetchAppDetail: (appId) => {
            if (appId == '' || appId === 'APP') {
                dispatch({
                    type: "APP_DETAIL_INIT",
                    payload: 'Application'
                })
            } else {
                dispatch({
                    type: "APP_DETAIL",
                    payload: WebAPI.getData("/app/detail/" + appId.substring(4))
                })
            }
        }
    })
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard))